import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintenanceManGetDeviceInfoByDeviceId
    (id) {
    return maintainRequest.get(`/device/maintenanceMan/chargingPile/getDeviceInfoByDeviceId/${id}`)
}
